import { orderBy, values } from 'lodash-es';

import { FullNameWithHabilitation } from '../types';
import { HabilitationI18nMap } from '../types/habilitation-i18n-map';
import { genericFormatName } from './generic-format-name';

export const formatNameWithTitles = <H extends string>(habilitationI18n: HabilitationI18nMap<H>) => {
  const possibleTitlesRegex = new RegExp(
    `\\b(${(orderBy(values(habilitationI18n), 'length', 'desc') as string[]).map(pt => pt.replace('.', '\\.')).join('|')})`,
    'ig',
  );
  return (data?: FullNameWithHabilitation<H> | null, fallback = '-'): string => {
    if (!data) return fallback;
    if (!data.habilitation) return genericFormatName(data, fallback);

    let includedTitle = habilitationI18n[data.habilitation as H] ?? '';
    let firstName = data.firstName ?? data.name;
    let lastName = data.lastName ?? data.surname;
    includedTitle = firstName?.match(possibleTitlesRegex)?.[0] ?? lastName?.match(possibleTitlesRegex)?.[0] ?? includedTitle;
    firstName = firstName?.replace(includedTitle, '').trim();
    lastName = lastName?.replace(includedTitle, '').trim();

    const fullName = genericFormatName({ firstName, lastName }, fallback);
    return includedTitle && fullName !== fallback ? `${includedTitle} ${fullName}` : fullName;
  };
};
